import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FAQ {
  question: string;
  answer: string;
}

interface CapsuleFAQProps {
  faqs: FAQ[];
}

export function CapsuleFAQ({ faqs }: CapsuleFAQProps) {
  return (
    <section className="py-24 md:py-32 px-4 bg-background">
      <div className="max-w-4xl mx-auto space-y-16">
        {/* Header minimalista */}
        <div className="text-center space-y-4">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-light tracking-tight">
            Preguntas frecuentes
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-light leading-relaxed">
            Lo que otros negocios nos preguntan
          </p>
        </div>

        {/* Accordion minimalista */}
        <Accordion type="single" collapsible className="w-full space-y-2">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border-b border-border/50"
            >
              <AccordionTrigger className="text-left text-xl md:text-2xl font-light hover:no-underline py-8 hover:text-primary transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base md:text-lg text-muted-foreground leading-relaxed pb-8 font-light">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* CTA minimalista */}
        <div className="text-center pt-12">
          <p className="text-lg md:text-xl text-muted-foreground font-light leading-relaxed">
            ¿Tienes más dudas?{" "}
            <a 
              href="/contacto" 
              className="text-foreground hover:text-primary transition-colors underline decoration-primary/30 underline-offset-4"
            >
              Hablemos
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
